<section class="p-[2rem]">
  <div class="flex flex-col gap-[0.75rem]">
    <div class="h-[5rem] w-[5rem] min-w-[5rem] bg-[url('/imgs/icon-red-alert-prohibition-symbol-3d-bubble.png')] bg-cover bg-no-repeat bg-center"></div>
    <span
      class="text-(--p-primary-500) text-base font-semibold leading-6"
      translate="@@dialog-forbidden-error-intercepted__title">
    </span>

    <div class="flex flex-col text-xs font-medium leading-[1.125rem] text-dark gap-2">
      <span translate="@@dialog-forbidden-error-intercepted__line1"></span>

      <span translate="@@dialog-forbidden-error-intercepted__line2"></span>

      <span translate="@@dialog-forbidden-error-intercepted__line3"></span>
    </div>

    <div class="flex flex-row items-center justify-end mt-2">
      <p-button
        (click)="close()"
        [label]="'@@shared-log-out__text' | translate">
      </p-button>
    </div>
  </div>
</section>

